'use strict';
/**
 * @author Maxim Seredkin
 */
export default['$rootScope', '$scope',
    function ($rootScope, $scope) {

        $scope.setFilter = setFilter;
        $scope.selectAll = selectAll;

        init();

        // region Functions

        function init() {
            $rootScope.title = "Площадки";

            $scope.filter = {
                enabled: false,
                deleted: false,
            };

            _update();
        }

        function _update() {
            $scope.filters = [];
            if ($scope.filter.enabled)
                $scope.filters.push("'status' EQ 'ENABLED'");
            if ($scope.filter.deleted)
                $scope.filters.push("'status' EQ 'DELETED'");
        }

        function setFilter() {
            _update();
        }

        function selectAll() {
            $scope.filter.enabled = true;
            $scope.filter.deleted = true;
            _update();
        }

        // endregion

    }]